module.exports = __webpack_public_path__ + "static/img/6.47a5147.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/6.png
// module id = PQZf
// module chunks = 0